/** 
 * Reload the page normally (keeps browser history)
 */
export const reloadPage = () => {
    window.location.reload();
};

/**
 * Force a full page reload (does not keep current page in history)
 */
export const forceReload = () => {
    window.location.replace(window.location.href);
};


/**
 * Navigate to an internal route
 * @param {string} route - Route path from ROUTES.*
 */
export const openPage = (route) => {
    window.location.href = route;
};